"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const material_1 = require("@mui/material");
const categories_1 = require("companion-app-components/flux/categories");
const selectors_1 = require("data/transactions/selectors");
const TxnBubble_1 = __importDefault(require("./TxnBubble"));
const utils_1 = require("../utils");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.dayStyles);
const Day = ({ day, currentMonth, currentDay, txnList, date, onTxnsModalOpen, rowSize }) => {
    const { classes, cx } = useStyles();
    const filteredTxnList = (0, react_redux_1.useSelector)((state) => (0, selectors_1.filterDashboardCalendarTxnBasedOnPref)(state, { txnList }));
    const incomeCOAIds = (0, react_redux_1.useSelector)((state) => categories_1.categoriesSelectors.getIncomeCOAIds(state));
    const renderedTxnList = (0, react_1.useMemo)(() => {
        const dayTxnTypeObjList = (0, utils_1.getUniqueTxnTypeList)(filteredTxnList, incomeCOAIds);
        return dayTxnTypeObjList && dayTxnTypeObjList.map((typeObj) => <TxnBubble_1.default key={typeObj.id} txn={typeObj}/>);
    }, [filteredTxnList, incomeCOAIds]);
    const cachedOnTxnsModalOpen = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        if (onTxnsModalOpen) {
            onTxnsModalOpen(date, filteredTxnList);
        }
    }, [onTxnsModalOpen, date, filteredTxnList]);
    return (<material_1.Grid className={cx(classes.day, rowSize === 6 ? 'small' : 'big', { [classes.notCurrentMonth]: !currentMonth }, { [classes.currentDay]: currentDay })} onClick={cachedOnTxnsModalOpen}>
      <header className={classes.header}>
        <div style={{ height: rowSize === 6 ? '22px' : '' }}>
          <span className={cx(classes.dayIndicator)}>{day}</span>
        </div>
        {(filteredTxnList === null || filteredTxnList === void 0 ? void 0 : filteredTxnList.size) > 0 && (<div className={classes.txnWrapper}>
            {renderedTxnList && renderedTxnList}
          </div>)}
      </header>
    </material_1.Grid>);
};
Day.whyDidYouRender = true;
exports.default = (0, react_1.memo)(Day);
